module.exports = __webpack_public_path__ + "0304f23dba2977248b8c4ca96910881a.svg";